import React from 'react';
import Collapsible from 'react-collapsible';

import { AccessOverviewHeading } from 'screens/AuditScreens';
import { AccessListItemPerson } from '../AccessListItem';

import styles from './AccessOverview.module.scss';

interface AccessOverviewPersonProps {
  people: any;
  total: number;
  onViewAll: () => void;
  title: string;
  subtitleOpen: string;
  subtitleClosed: string;
  buttonMessage: string;
  isOpen?: boolean;
  isOutsideOwner?: boolean,
  handleTriggerClick: any;
}

export const AccessOverviewPerson = ({
  people,
  total,
  onViewAll,
  title,
  subtitleOpen,
  subtitleClosed,
  buttonMessage,
  isOpen,
  isOutsideOwner,
  handleTriggerClick,
}: AccessOverviewPersonProps) => {
  return (
    <Collapsible
      classParentString=""
      triggerTagName="div"
      triggerClassName={total > 0 ? styles.trigger : styles.disabled}
      triggerOpenedClassName={styles.trigger}
      openedClassName={styles.container}
      className={styles.container}
      contentOuterClassName={styles.contentOuter}
      contentInnerClassName={styles.contentInner}
      transitionTime={150}
      easing="ease-in-out"
      trigger={
        <AccessOverviewHeading
          title={title}
          subtitle={subtitleOpen}
          complete={total > 0 ? false : true}
        />
      }
      triggerWhenOpen={
        <AccessOverviewHeading
          title={title}
          subtitle={subtitleClosed}
          complete={total > 0 ? false : true}
        />
      }
      open={total > 0 ? isOpen : false}
      handleTriggerClick={total > 0 ? handleTriggerClick : function () {}}
    >
      <div className={styles.bin}>
        {people.slice(0, 2).map((person: any, key: number) => (
          <AccessListItemPerson key={key} person={person} buttonMessage={buttonMessage} isOutsideOwner={isOutsideOwner} />
        ))}
      </div>
      <div onClick={onViewAll} className={styles.viewAll}>
        View all {total.toLocaleString()} people
      </div>
    </Collapsible>
  );
};
